/**
 * Agent flows API — frontend-first: persiste en localStorage por compañía.
 * Sustituir por fetch a /api/agent-flows cuando exista el backend.
 */
import { getUser } from './auth';
import { createDefaultFlowConfig } from './agentFlowSchema';

const STORAGE_VERSION = 'v1';

const storageKey = () => {
  const user = getUser();
  const cid = user?.companyId || user?.idcompany || 'local';
  return `bankivo_agent_flows_${STORAGE_VERSION}_${cid}`;
};

const newId = () =>
  typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `af_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;

function readAll() {
  try {
    const raw = localStorage.getItem(storageKey());
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeAll(flows) {
  localStorage.setItem(storageKey(), JSON.stringify(flows));
}

export const agentFlowsApi = {
  listFlows: async () => {
    const flows = readAll();
    return [...flows].sort((a, b) => (b.updatedAt || '').localeCompare(a.updatedAt || ''));
  },

  getFlow: async (id) => {
    const flows = readAll();
    return flows.find((f) => f.id === id) || null;
  },

  createFlow: async ({ name }) => {
    const now = new Date().toISOString();
    const row = {
      id: newId(),
      name: name?.trim() || 'Flujo sin nombre',
      status: 'draft',
      flow_config: createDefaultFlowConfig(),
      createdAt: now,
      updatedAt: now,
    };
    const flows = readAll();
    flows.push(row);
    writeAll(flows);
    return row;
  },

  updateFlow: async (id, patch) => {
    const flows = readAll();
    const i = flows.findIndex((f) => f.id === id);
    if (i === -1) throw new Error('Flujo no encontrado');
    const next = {
      ...flows[i],
      ...patch,
      updatedAt: new Date().toISOString(),
    };
    flows[i] = next;
    writeAll(flows);
    return next;
  },

  deleteFlow: async (id) => {
    const flows = readAll().filter((f) => f.id !== id);
    writeAll(flows);
  },
};
